import Cookies from 'js-cookie'

import { CookieSettings } from '@cookieManage/types/CookieManage.interface'

const COOKIE_SETTING_KEY = 'cookie_settings'
const COOKIE_PERMISSION_KEY = 'cookie_permission'

class CookiesManager {
  public toggleSupportCookie(support: boolean) {
    const intercomMockClassName = 'intercom-mock'
    const mockIntercom: HTMLElement | null = document.querySelector(`.${intercomMockClassName}`)

    if (!mockIntercom) return

    if (support) {
      mockIntercom.className = `${intercomMockClassName} --hide`
      window?.Intercom?.('update')
    } else {
      mockIntercom.className = `${intercomMockClassName} --show`
      window?.Intercom?.('shutdown')
    }
  }

  public setCookieSettings(settings: CookieSettings) {
    Cookies.set(COOKIE_SETTING_KEY, JSON.stringify(settings))
  }

  public getCookiePermission() {
    const cookiePermission = Cookies.get(COOKIE_PERMISSION_KEY)

    return cookiePermission || null
  }

  public getCookieSettings() {
    const cookieSettings = Cookies.get(COOKIE_SETTING_KEY)

    return cookieSettings ? JSON.parse(cookieSettings) : null
  }

  public acceptAllCookieSettings() {
    const enabledCookieSettings = {
      performance: true,
      advertising: true,
      support: true,
    }

    Cookies.set(COOKIE_SETTING_KEY, JSON.stringify(enabledCookieSettings))
  }

  public resetAllCookieSettings() {
    const disabledCookieSettings = {
      performance: false,
      advertising: false,
      support: false,
    }

    Cookies.set(COOKIE_SETTING_KEY, JSON.stringify(disabledCookieSettings))
  }

  public setAllCookies() {
    this.acceptAllCookieSettings()
    this.toggleSupportCookie(true)
    window?.toggleGtagCookies?.(true, true)
  }

  public resetAllCookies() {
    window?.toggleGtagCookies?.(false, false)
    this.resetAllCookieSettings()
    this.toggleSupportCookie(false)
  }

  public setCookies(newSettings: CookieSettings) {
    const cookieSettings = this.getCookieSettings() || {}
    const mergedSettings = { ...cookieSettings, ...newSettings }

    this.setCookieSettings(mergedSettings)
    const { performance, advertising, support } = mergedSettings

    this.toggleSupportCookie(support)
    window?.toggleGtagCookies?.(performance, advertising)
  }
}

export default new CookiesManager()
